import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';

import { IMAGE_NOT_FOUND_FALLBACK } from '../constants';
import {
	CapturedImage,
	ImageContainer,
	ImageEmotion,
	ImagePlaceholder,
	ImagesGrid,
	ImagesSection,
	ImagesSectionTitle,
} from '../styles';
import { getImageUrl } from '../utils';

interface EntryImagesProps {
	images: Array<{
		id: string;
		url?: string;
		signed_url?: string;
		file_name: string;
		emotion?: string;
	}>;
}

export default function EntryImages({ images }: EntryImagesProps) {
	const { formatMessage } = useIntl();

	if (!images || images.length === 0) return null;

	return (
		<ImagesSection>
			<ImagesSectionTitle>
				<Text>{formatMessage(messages.entryCapturedImages)}</Text>
			</ImagesSectionTitle>
			<ImagesGrid>
				{images.map((image, idx) => {
					const imageUrl = getImageUrl(image);
					return (
						<ImageContainer key={image.id}>
							{imageUrl ? (
								<CapturedImage
									src={imageUrl}
									alt={`Captured emotion ${idx + 1}`}
									onError={e => {
										e.currentTarget.src = IMAGE_NOT_FOUND_FALLBACK;
									}}
								/>
							) : (
								<ImagePlaceholder>{formatMessage(messages.entryCapturedImages)}</ImagePlaceholder>
							)}
							{image.emotion && (
								<ImageEmotion>
									<Text>{image.emotion}</Text>
								</ImageEmotion>
							)}
						</ImageContainer>
					);
				})}
			</ImagesGrid>
		</ImagesSection>
	);
}
